import { render, staticRenderFns } from "./videoModel.vue?vue&type=template&id=54986aae&scoped=true&"
import script from "./videoModel.vue?vue&type=script&lang=js&"
export * from "./videoModel.vue?vue&type=script&lang=js&"
import style0 from "./videoModel.vue?vue&type=style&index=0&id=54986aae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54986aae",
  null
  
)

export default component.exports